import { render, staticRenderFns } from "./tnc-en.vue?vue&type=template&id=7978ae7e&scoped=true"
import script from "./tnc-en.vue?vue&type=script&lang=js"
export * from "./tnc-en.vue?vue&type=script&lang=js"
import style0 from "./tnc-en.vue?vue&type=style&index=0&id=7978ae7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7978ae7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7978ae7e')) {
      api.createRecord('7978ae7e', component.options)
    } else {
      api.reload('7978ae7e', component.options)
    }
    module.hot.accept("./tnc-en.vue?vue&type=template&id=7978ae7e&scoped=true", function () {
      api.rerender('7978ae7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/tnc/tnc-en.vue"
export default component.exports